import { render, staticRenderFns } from "./NoticiasMercadoVideosSugeridos.vue?vue&type=template&id=7129c268&"
import script from "./NoticiasMercadoVideosSugeridos.vue?vue&type=script&lang=js&"
export * from "./NoticiasMercadoVideosSugeridos.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasMercadoVideosSugeridos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports